enum AuthorityLevels {
  GROUP_ADMIN = 'Group Admin',
  CLIENT_ADMIN = 'Client Admin',
}
export default AuthorityLevels;
